"use client"

import { useCallback, useMemo } from "react"
import { useLanguage } from "@/contexts/language-context"
import { formatNumber, translate, type Locale, type TranslationKey, type TranslationVariables } from "@/lib/translations"

export interface Translator {
  locale: Locale
  /** The string for a key in the active language, with {{placeholders}} filled from `variables` */
  t: (key: TranslationKey, variables?: TranslationVariables) => string
  /** A number with the active language's digit grouping */
  n: (value: number) => string
}

/** Access to the active language's strings inside components */
export function useTranslation(): Translator {
  const { language } = useLanguage()
  const t = useCallback((key: TranslationKey, variables?: TranslationVariables) => translate(language, key, variables), [language])
  const n = useCallback((value: number) => formatNumber(language, value), [language])
  return useMemo(() => ({ locale: language, t, n }), [language, t, n])
}
